/**
 * @generated SignedSource<<2f55a11d12df601550d721714eeb5178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicNoteOriginalImageExtractorInput = {
  bulb_id: string;
  note_id: string;
  piece_id: string;
  sheet_id: string;
};
export type NoteOriginalImageExtractorMutation$variables = {
  input: MusicNoteOriginalImageExtractorInput;
};
export type NoteOriginalImageExtractorMutation$data = {
  readonly music_note_original_image_extractor: {
    readonly job_id: string;
  };
};
export type NoteOriginalImageExtractorMutation = {
  variables: NoteOriginalImageExtractorMutation$variables;
  response: NoteOriginalImageExtractorMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicNoteOriginalImageExtractorOutput",
    "kind": "LinkedField",
    "name": "music_note_original_image_extractor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "job_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteOriginalImageExtractorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteOriginalImageExtractorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df3cf5a6d6be48a9e2367c79111cafe7",
    "id": null,
    "metadata": {},
    "name": "NoteOriginalImageExtractorMutation",
    "operationKind": "mutation",
    "text": "mutation NoteOriginalImageExtractorMutation(\n  $input: MusicNoteOriginalImageExtractorInput!\n) {\n  music_note_original_image_extractor(input: $input) {\n    job_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6983e0ee18186aea3a6b912d713c0bca";

export default node;
